import React, { useCallback } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Tabs } from '@beef/ui-kit';
import classNames from 'classnames/bind';

import { onProductDetailsMenuClick, setActiveSection } from 'store/ProductDetails/common/actions';
import { getActiveContentTabSlug, getContentTabsList } from 'store/ProductDetails/selectors';
import commonStyles from 'styles/common.pcss';

import styles from './styles.pcss';

const cx = classNames.bind({ ...styles, ...commonStyles });

const FollowTabs = () => {
  const dispatch = useDispatch();

  const { selectedTab, tabs } = useSelector(
    (state) => ({
      selectedTab: getActiveContentTabSlug(state),
      tabs: getContentTabsList(state),
    }),
    shallowEqual,
  );

  const onChange = useCallback(
    (activeSlug) => {
      dispatch(setActiveSection(activeSlug));
      /** Вынес логику Яндекс Метрики в отдельный action onFollowTabClick,
       *   так как setActiveSection используется не только в меню карточки продукта
       */
      dispatch(onProductDetailsMenuClick(activeSlug));
    },
    [dispatch],
  );

  return (
    <div className={cx('wrapper')}>
      <Tabs
        isScrollable
        noWrap
        onChange={onChange}
        selectedTab={selectedTab}
        tabs={tabs}
        variant="tertiary"
      />
    </div>
  );
};

export default FollowTabs;
